<template>
  <div class="page">
    <navigation class="nav">邀请有奖</navigation>
    <div class="container">
      <div class="card">
        <div class="card-title">如何赚到现金</div>
        <div class="content">
          <div class="section">
            <div class="title">福利详情</div>
            <p>福利1：活动期间，每邀请一个新用户在天美贷提现成功，奖励50元</p>
            <p>福利2：活动期间，每邀请一个新用户浏览两款天美贷推荐产品，奖励2元</p>
          </div>
          <div class="section">
            <div class="title">活动步骤</div>
            <p>1、分享活动链接，用户通过您分享的活动链接首次注册天美贷</p>
            <p>2、好友在天美贷首次提现成功或浏览两款天美贷推荐产品</p>
            <p>3、现金奖励发放至您的券包</p>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-title">活动规则</div>
        <div class="content">
          <div class="section">
            <div class="title">活动对象</div>
            <p>天美贷指定用户</p>
          </div>
          <div class="section">
            <div class="title">活动内容</div>
            <p>1、活动期间，每邀请一个新用户在天美贷首次提现成功，奖励50元；如邀请2个人在天美贷提现成功，则获得100元奖励</p>
            <p>2、活动期间，每邀请一个新用户浏览两款天美贷推荐产品，奖励2元；如邀请2个人，均浏览两款天美贷推荐产品，则获得4元奖励；活动邀请链接有效期为3天，有效期结束后请点击活动页面的邀请按钮，生成新的邀请链接</p>
          </div>

          <div class="section">
            <div class="title">现金奖励发放方式</div>
            <p>活动期间，1个自然月为1个结算周期，月初的5个工作日内将结算您在上一个月获得的所有现金奖励，并发放至券包。登录天美贷---我的---券包，提现红包</p>
          </div>
        </div>
      </div>
      <div class="footer">活动所有解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    // todo: 活动时间取值？
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: linear-gradient(180deg, #FB2920 0%, #FDCE99 30%, #FD8D7A 80%, #FD4642 100%);
  min-height: 100vh;
  .container {
    padding: 40px;
    .card {
      border-radius: 30px;
      background-color: white;
      margin-bottom: 20px;
      .card-title {
        position: relative;
        display: flex;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        color: #94390D;
        line-height: 40px;
        letter-spacing: 1px;
        text-align: left;
        gap: 20px;
        align-items: center;
        background: #FFF2E5;
        height: 90px;
        box-shadow: inset 0px 3px 5px 0px #FFF4DA;
        border-radius: 30px 30px 0px 0px;
        justify-content: center;
        &:after,&:before {
          content: '';
          display: block;
          width:198px;
          height:18px;
          background: url('./images/img_left@2x.png') no-repeat ;
          background-size: 100% 100%;
        }
        &:after { 
          transform: rotateY(180deg);
        }
      }
    }
    .content {
      padding: 60px 30px;
      .section {
        margin-bottom: 60px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #333333;
          line-height: 45px;
        }
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 37px;
          padding: 5px 0;
        }
      }
    }
    .footer {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #fff;
      line-height: 33px;
      margin-top: 50px;
    }
  }
}
</style>